import {
  DrugItemDrawerAboutSection,
  DrugItemDrawerClassificationSection,
} from '@/modules/drug-catalog/components/drug-item-drawer/drug-item-drawer-sections'
import {DataList} from '@cypro/ui/components/ui/data-list'
import {DataSection} from '@cypro/ui/components/ui/data-section'
import {useSolutionDrugContext} from '@/shared/contexts/solution-drug'
import {Tabs} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

export function AboutTab() {
  const {t} = useTranslate('common')
  const {solutionDrug} = useSolutionDrugContext()

  const {properties} = useMemo(() => {
    const types = solutionDrug.solutionDetails?.types?.map(type => type.solutionType?.name)

    return {
      properties: [
        {label: t('concentration_value'), value: solutionDrug.solutionDetails?.concentrationValue},
        {label: t('concentration_unit'), value: solutionDrug.solutionDetails?.concentrationUnit?.ucumCode},
        {
          label: t('types'),
          value: types?.join(', ') || t('no_types'),
        },
      ],
    }
  }, [t, solutionDrug])

  return (
    <Tabs.Content value="about" spaceY="8" display="flex" flexDirection="column">
      <DrugItemDrawerAboutSection drugItem={solutionDrug} />

      <DrugItemDrawerClassificationSection drugItem={solutionDrug} />

      <DataSection label={t('properties')}>
        <DataList items={properties} />
      </DataSection>
    </Tabs.Content>
  )
}
